import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { debounceTime, map, distinctUntilChanged } from 'rxjs/operators';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { Location } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import * as XLSX from 'xlsx';

import { GlobalsService } from '../../services/globals.service';
import { InventoryService } from '../../services/inventory.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

@Component({
	selector: 'app-inventory-upload',
	templateUrl: './inventory-upload.component.html',
	styleUrls: ['./inventory-upload.component.scss'],
	animations: [
		trigger('grow', [ // Note the trigger name
	  transition(':enter', [
		  // :enter is alias to 'void => *'
		  style({ height: '0',width: '0', overflow: 'hidden' }),
		  animate(200, style({ height: '*' , width: '*' })),
		  animate('200ms', style({ opacity: 1 })),
	  ]),
	  transition(':leave', [
		  // :leave is alias to '* => void'
		  animate(300, style({ height: 0, width: 0 , overflow: 'hidden' })),
		  animate('300ms', style({ opacity: 0 }))
	  ])
	  ]),
	]
})
export class InventoryUploadComponent {
@Input() item;
	@Output() editing = new EventEmitter<boolean>();
	@Output() newitemdata = new EventEmitter<boolean>();
	@ViewChild('eventRef') eventRef: ElementRef;
	files: File[] = [];
	uploadFiles: any[] = [];
	itemForm: any = false;
	uploadresults: any = [];
	properties: any = [];
	formEditAllowed = [
		'stockid',
		'image',
	]
	UploadedHeaders: string[] = [];
	UploadFileSpecificHeaders: {
		[fileName: string]: string[]
	} = {};
	UploadFileSpecificMappings: {
		[fileName: string]: {
			[header: string]: string
		}
	} = {};
	uploaddata: any = false;
	mapcols: any = [];
	mapping: any = [];
	mapped: any = [];
	optionForm = new UntypedFormGroup({});
	mappingForm = new UntypedFormGroup({});
	rowNumber = new UntypedFormControl('1');
	color: any = 'blue';
	isLoading = false
	config: any = [];
	sending = false
	filelist: any = [];
	mappeddata: any = [];
	preview: any = false;
	colspan: any = 0;
	investigation: any = '';
	investigated: any = '';
	preflight = new UntypedFormControl(true);

	constructor(private globalSearchService: GlobalSearchService, private modalService: NgbModal, private route: ActivatedRoute, private fb: UntypedFormBuilder,private inventoryService: InventoryService, public router: Router, private location: Location, private globalsService: GlobalsService) {
		this.color = this.globalSearchService.getColor();
		this.globalSearchService.configsubscription.subscribe((r:any) => {
			this.config = r;
		})
	}

	onSubmit() {


	}

	ngOnInit(): void {

		this.inventoryService.getBatchUpload().subscribe( r => {
			this.filelist = r
		})
		
		this.optionForm = this.fb.group({
			stockmaster: [false],
			prices: [false],
			purchdata: [false],
			pricematrix: [false],
			tireinfo: [false],
		});
	}

	onSelect(event: any) {
		this.uploadFiles.push(...event.addedFiles);
		
		this.processUploadSelect();
		
	}
	adjustMapping(){
		this.mapcols=[{ 'field':'stockid','label':'Item Number', 'req': true }];
		this.mappingForm = new UntypedFormGroup({});
		if(this.optionForm.get('prices')?.value === true || this.optionForm.get('pricematrix')?.value === true){
			this.mapcols.push({ 'field':'salestype', 'label':'Price Level', 'req':true });
			this.mapcols.push({ 'field':'currabrev','label':'Currency','req':false });
		}
		if(this.optionForm.get('stockmaster')?.value === true){
			const stockmasterfields = [
									 { 'field':'lineid', 'label':'Product Line', 'req':false },
									 { 'field':'categoryid','label':'Item Category', 'req':false },
									 { 'field':'description','label':'Item Description', 'req':false },
									 { 'field':'units','label':'Unit of Measure', 'req':false },
									 { 'field':'cost','label':'Cost', 'req':false },
									 { 'field':'taxcatid','label':'Tax Category', 'req':false },
									 { 'field':'barcode','label':'UPC Code', 'req':false },									 
									 { 'field':'additionalfee','label':'Excise Tax', 'req':false },								 
									 { 'field':'sort','label':'Lookup Field 1', 'req':false },
									 { 'field':'sort2','label':'Lookup Field 2', 'req':false },
									 { 'field':'mfgpart','label':'Manufacturer Part Number', 'req':false },								 
									 { 'field':'mfgname','label':'Brand', 'req':false },
									 { 'field':'min', 'label':'Minimum Stock','req':false },
									 { 'field':'max', 'label':'Maximum Stock','req':false },								 
									 ];
			this.mapcols.push(...stockmasterfields);
		}
		if(this.optionForm.get('prices')?.value === true){
			const pricefields = [
									 { 'field':'price','label':'Sales Price', 'req':true },
									 { 'field':'startdate','label':'Price Start Date','req':false },
									 { 'field':'enddate','label':'Price End Date','req':false },
									 ];
			this.mapcols.push(...pricefields);
		}
		if(this.optionForm.get('purchdata')?.value === true){
			const purchfields = [
									 { 'field':'supplierno', 'label':'Vendor Code', 'req':true },
									 { 'field':'supplierprice','label':'Purchase Price', 'req':true },
									 { 'field':'suppliersuom','label':'Purchase Unit of Measure', 'req':false },
									 { 'field':'supplierdescription','label':'Supplier Description', 'req':false },
									 { 'field':'conversionfactor','label':'Conversion Factor','req':false },
									 { 'field':'suppliers_partno','label':'Vendor Part Number','req':false },
									 { 'field':'effectivefrom','label':'Purchase available from date','req':false },
									 { 'field':'minorderqty','label':'Min Purchase Qty', 'req':false },
									 { 'field':'maxorderqty','label':'Max Purchase Qty', 'req':false },
									 ];
			this.mapcols.push(...purchfields);
		}
		
		if(this.optionForm.get('pricematrix')?.value === true){
			const breakfields = [
									 { 'field':'quantitybreak','label':'Price Break Qty', 'req':true },
									 { 'field':'breakprice','label':'Break Price','req':true },
									 { 'field':'breakstartdate','label':'Price Break Start', 'req':true },
									 { 'field':'breakenddate','label':'Price Break End', 'req':true },
									 ];
			this.mapcols.push(...breakfields);
		}
		this.mapcols.forEach((m) => {
			if(m.req == true){
				this.mappingForm.addControl(m.field, new UntypedFormControl('',[Validators.required]));
			} else {
				this.mappingForm.addControl(m.field, new UntypedFormControl('',[]));
			}
		});
		console.log(this.mapcols);
	}
	async processUploadSelect() {
		this.isLoading = true
		if (this.uploadFiles.length === 0) {return;}
		
		
		let allFileData: any[] = [];
		let filesProcessed = 0;
		for (let i = 0; i < this.uploadFiles.length; i++) {
			const file = this.uploadFiles[i];
			const name = file.name;
			const type = file.type;


			try {
				const fileContents = await this.readFile(file);
			
				const workbook = XLSX.read(fileContents, { type: 'binary' });
			
				const sheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[sheetName];
				const headerRow = parseInt(this.rowNumber.value) - 1;
				
				const rows: Record < string, any > [] = XLSX.utils.sheet_to_json(worksheet, { range: headerRow, defval: '' });

				
				const dataWithFileSource = rows.map(row => ({ ...row, _sourceFile: name }));
				allFileData = [...allFileData, ...dataWithFileSource];

				console.log(allFileData);
				this.uploaddata = allFileData;
				if (rows && rows.length > 0) {
					
					const currentHeaders = Object.keys(rows[headerRow]);
					this.UploadFileSpecificHeaders[name] = [...currentHeaders];
					this.UploadedHeaders = [...new Set([...this.UploadedHeaders, ...currentHeaders])];
				}

				filesProcessed++;
			} catch (error) {
				filesProcessed++;
				console.error('Error processing file:', error);
				this.globalSearchService.showNotification('Error processing file: ' + name, 'danger', 'bottom', 'left');
			}
		}

		this.isLoading = false
	}

	onRemove(event: any) {
		this.uploaddata = [];
		this.UploadedHeaders = [];
		this.UploadFileSpecificHeaders = {};
		this.uploadFiles.splice(this.uploadFiles.indexOf(event), 1);
		
		this.processUploadSelect();
	}
	remap(){
		
		this.preview = false;
	}
	
	investigate(row: any){
	
		const data = { 'data': row, 'update': this.optionForm.value };
	
		this.inventoryService.investigate(data).subscribe((r: any) => {
			this.investigation = r.result;
			this.investigated = row.stockid;
			this.modalService.open(this.eventRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {
				
			});
		});
	
	}

	readFile(file: File): Promise < string > {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(reader.result as string);
			reader.onerror = reject;
			reader.readAsBinaryString(file);
		});
	}

	prepFileExport(f:any) {
		const data = {
			batch_id: f.batch_id,
			file: f.name
		}
		this.sending = true;
		this.inventoryService.prepExportUpload(data).subscribe((results: any) => {
			this.sending = false;
			this.uploaddata = results;

		});
	}

	prepFile(f:any) {
		const data = {
			batch_id: f.batch_id,
			file: f.name
		}
		this.sending = true;
		this.inventoryService.prepUpload(data).subscribe((results: any) => {
			this.sending = false;
			this.uploaddata = results;

		});

	}
	submit(){
		const data = { 'data': this.mappeddata, 'update': this.optionForm.value };
		let msg = '';
		this.inventoryService.inventoryUpload(data).subscribe((r: any) => {
			if (r.sm != null){
			msg += 'New Items Added         :'+r.sm.new+'<br>';
			msg += 'Items Updated           :'+r.sm.updates+'<br>';
			}
			if (r.pr != null){
			msg += 'New Prices Added        :'+r.pr.new+'<br>';
			msg += 'Prices Updated          :'+r.pr.updates+'<br>';
			}
			if (r.pd != null){
			msg += 'New Purchase Data Added :'+r.pd.new+'<br>';
			msg += 'Purchase Data Updated   :'+r.pd.updates+'<br>';
			}
			if (r.pm != null){
			msg += 'New Price Matrix Added  :'+r.pm.new+'<br>';
			msg += 'Price Matrix Updated    :'+r.pm.updates+'<br>';
			}
			this.mappeddata =[];
			this.uploaddata = [];
			this.uploadFiles = [];
			this.globalSearchService.showNotification(msg, 'success', 'bottom', 'left');
		});
	}
	process(upload: any) {
		this.preview = true;
		const mapping = this.mappingForm.value;
		this.mapped = [];
		Object.entries(mapping).forEach(([key, value]) => {
			if(value != ''){
				this.mapped.push(this.mapcols.find(map => map.field === key ));
			}
		});
		this.mappeddata = [];
		upload.forEach((e) => {
			const line = new Object;
			Object.entries(mapping).forEach(([key, value]) => {
			
				if(value != '')
				{
					line[key] = e[value.toString()];
				
				}
			});
			this.mappeddata.push(line);
		});
		this.colspan = this.mapped.length;
		//quickcheck
		const data = { 'lines': this.mappeddata };
		this.inventoryService.quickCheck(data).subscribe((results: any) => {
		
			this.mappeddata = results;
			this.mappeddata.forEach((e) => {
		
				if(!e.exists){
				  if(!e.categoryid){
						this.mappeddata[this.mappeddata.indexOf(e)].problem += ' Needs Category to add Item <br>';
					} 
					if (!e.lineid){
						this.mappeddata[this.mappeddata.indexOf(e)].problem += ' Needs Product Line to add Item <br>';
					}
					if (!e.mfgname){
						this.mappeddata[this.mappeddata.indexOf(e)].problem += ' Needs Brand to add Item <br>';
					}
				}
			});
		});
	}
	removeFile(f: any) {

		const data = {
			batch_id: f.batch_id,
			file: f.name
		}
		this.inventoryService.removeUpload(data).subscribe((results: any) => {
			this.filelist = results
		});

	}
	ngAfterViewInit(): void {

	}
	back(): void {
		this.location.back()
	}


}
